import Formula, { FormulaJSON } from '../../HCLTreeVertexValue/Formula';
import Label, { LabelJSON } from '../../HCLTreeVertexValue/Label';
import ProxyType from '../../HCLTreeVertexValue/ProxyTypes';
import GateVertexValue, { GateVertexValueJSON } from '../GateNode/GateVertexValue';
import ReferenceTypes from '../../HCLTreeVertexValue/ReferenceTypes';
import { OutcomeJSON } from '../../HCLTreeVertexValue/Outcome';

export interface FaultTreeTransferGateVertexValueJSON extends GateVertexValueJSON {
  formula: OutcomeJSON;
}

class FaultTreeTransferGateVertexValue extends GateVertexValue {

  public constructor(label?: Label, formula?: Formula) {
    super(label, formula);
  }

  protected getDefaultOutcomeJSON(): OutcomeJSON {
    return {
      reference_type: ReferenceTypes.GATES,
      tree_id: 0,
      name: '0',
      _proxy: ProxyType.EVENT_REFERENCE,
    };
  }

  public getDefaultFormula(): Formula {
    const outcomeJSON: OutcomeJSON = this.getDefaultOutcomeJSON();
    return new Formula(outcomeJSON);
  }

  getDefaultLabel(): Label {
    return new Label('Transfer Gate', '');
  }

  getFormattedSubLabel(): string {
    try {
      const treeId = this.getFormula().getOutcome().getTreeId();
      if (treeId === 0) {
        return 'UNSET';
      }
      return `ID: ${treeId}`;
    } catch (e) {
      return 'UNSET';
    }
  }

  clone(): FaultTreeTransferGateVertexValue {
    return new FaultTreeTransferGateVertexValue(this.label.clone(), this.formula.clone());
  }
}

export default FaultTreeTransferGateVertexValue;
